import './style.scss';
import { useContext } from 'react';
import { FormDataContext } from '../FormDataProvider';

function ConfirmStep() {

    const { updateFormData, formData } = useContext(FormDataContext);

  return (
    <div className="confirm-step">
        <h2>Godkännande</h2>

        <label className="full check">
            <input type="checkbox" name="accept[]" value="accept" required onChange={(e) => updateFormData(e)} /><span>Jag har läst och godkänner Svenska Tecknares <a href="/medlemsvillkor/" target="_blank">medlemsvillkor</a>.</span>
        </label>
    </div>
  );
}

export default ConfirmStep;
